// useAnimation.js — page enter curtain (skip when coming from transition)
import { useEffect, useState } from "react";

const TRANSITION_MS = 1200;
const INITIAL_FADE_MS = 700;
let hasMountedInitialPage = false;

const useAnimation = (duration = TRANSITION_MS, skip = false) => {
  const animationMode = skip
    ? null
    : hasMountedInitialPage
      ? "curtain"
      : "fade";
  const activeDuration = animationMode === "fade" ? INITIAL_FADE_MS : duration;
  const [isAnimating, setIsAnimating] = useState(Boolean(animationMode));

  useEffect(() => {
    hasMountedInitialPage = true;

    if (!animationMode) {
      setIsAnimating(false);
      return;
    }
    const timer = setTimeout(() => setIsAnimating(false), activeDuration);
    return () => clearTimeout(timer);
  }, [activeDuration, animationMode]);

  return { isAnimating, animationMode };
};

export default useAnimation;
export { INITIAL_FADE_MS, TRANSITION_MS };
